import { render, staticRenderFns } from "./partyBuildingActivitiesAdd.vue?vue&type=template&id=9805ecfc&scoped=true&"
import script from "./partyBuildingActivitiesAdd.vue?vue&type=script&lang=js&"
export * from "./partyBuildingActivitiesAdd.vue?vue&type=script&lang=js&"
import style0 from "./partyBuildingActivitiesAdd.vue?vue&type=style&index=0&id=9805ecfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9805ecfc",
  null
  
)

export default component.exports